






















































import TemplatePreview from "@/pages/envios-automaticos/components/TemplatePreview.vue";
import {
  EnvioAutomatico,
  EnvioAutomaticoParametro,
  EnviosAutomaticosService,
  TemplateEnvioAutomatico,
  TipoParametro,
  TipoParametroEnvioAutomatico
} from "@/services/envios-automaticos.service";
import { ToastService } from "@/services/toast.service";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import { required } from "@/shared/validators";
import { Component, Vue, Watch } from "vue-property-decorator";

interface ParametroModel {
  region: TipoParametro;
  indiceBotao?: number;
  numeroParametro: number;
  tipoParametro: TipoParametroEnvioAutomatico | null;
  parametroManual: string | null;
  subTipoBotao?: string;
}

@Component({
  components: {
    Loading,
    Modal,
    TemplatePreview,
  },
})
export default class Manter extends Vue {
  envioAutomatico: EnvioAutomatico | null = null;
  envioAutomaticoParametros: EnvioAutomaticoParametro[] = [];
  valid = false;
  loading = false;
  templates: TemplateEnvioAutomatico[] = [];
  tiposParametro: Array<{ text: string; value: number }> = [
    { text: "Primeiro Nome", value: TipoParametroEnvioAutomatico.PrimeiroNome },
    { text: "Saudação", value: TipoParametroEnvioAutomatico.Saudacao },
    { text: "Catálogo", value: TipoParametroEnvioAutomatico.Catalogo },
    { text: "Último Pagamento", value: TipoParametroEnvioAutomatico.UltimoPagamento },
    { text: "Forma de Pagamento", value: TipoParametroEnvioAutomatico.FormaPagamento },
    { text: "Nome do Plano", value: TipoParametroEnvioAutomatico.NomePlano },
    { text: "Link de pagamento", value: TipoParametroEnvioAutomatico.LinkPagamento },
    { text: "Manual", value: TipoParametroEnvioAutomatico.Manual }
  ]

  parametros: ParametroModel[] | null = null;

  get parametrosCorpo(): ParametroModel[] {
    if (!this.parametros) return [];

    return this.parametros.filter(p => p.region === TipoParametro.Corpo);
  }

  get parametrosBotoes() {
    if (!this.parametros) return {};
    const grouped = {} as { [key: number]: ParametroModel[] };
    for (const parametro of this.parametros.filter(p => p.region === TipoParametro.Botao)) {
      if (!grouped[parametro.indiceBotao!]) {
        grouped[parametro.indiceBotao!] = [];
      }
      grouped[parametro.indiceBotao!].push(parametro);
    }
    return grouped;
  }

  rules = {
    templates: [required()],
    // tipoParametro e NOT NULL no banco: sem esta regra o form deixava salvar com o select
    // vazio, o nulo chegava no insert e o erro voltava como 500 generico.
    parametro: [required("Selecione o conteúdo deste parâmetro")],
  };

  public async editarEnvioAutomatico(id: string) {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    this.loading = true;
    try {
      this.envioAutomatico = await EnviosAutomaticosService.obterEnvioAutomatico(id);
      this.templates = await EnviosAutomaticosService.obterTemplates();
      this.envioAutomaticoParametros = await EnviosAutomaticosService.obterParametros(id);

      if (this.envioAutomaticoParametros && this.envioAutomaticoParametros.length > 0) {
        this.parametros = this.envioAutomaticoParametros
          .map(parametro => ({
            numeroParametro: parametro.numeroParametro,
            tipoParametro: parametro.tipoParametro,
            parametroManual: parametro.parametroManual,
            region: parametro.regiaoParametro,
            indiceBotao: parametro.indiceBotao,
            subTipoBotao: parametro.subTipoBotao
          }) as ParametroModel);
      }
    } finally {
      this.loading = false;
    }

    return p;
  }

  get templateSelecionado(): TemplateEnvioAutomatico | undefined {
    const selecionado = this.templates.find(
      t => t.nome === this.envioAutomatico?.template
    );
    return selecionado;
  }

  @Watch('envioAutomatico.template')
  onTemplateChanged() {
    this.envioAutomaticoParametros = [];
    this.parametros = null;

    const templateAtual = this.templateSelecionado;
    if (templateAtual) {
      this.parametros = templateAtual.parametros.map((parametro, index) => ({
        region: parametro.tipo,
        indiceBotao: parametro.indiceBotao,
        numeroParametro: index + 1,
        tipoParametro: null,
        parametroManual: null,
        subTipoBotao: parametro.subTipoBotao
      } as ParametroModel));
    }
  }

  async salvar() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (!form.validate()) {
      ToastService.open({
        message: this.mensagemDeCamposPendentes(),
        type: "error",
        duration: 5000,
        position: "bottom-end",
      });
      return;
    }

    this.loading = true;
    const envioAutomaticoParametros = this.parametros?.map((parametro) => {
      return {
        idEnvioAutomatico: this.envioAutomatico?.idEnvioAutomatico,
        numeroParametro: parametro.numeroParametro!,
        tipoParametro: parametro.tipoParametro,
        parametroManual: (parametro.tipoParametro == 99 && parametro.parametroManual) || null,
        ativo: true,
        regiaoParametro: parametro.region,
        indiceBotao: parametro.indiceBotao,
        subTipoBotao: parametro.subTipoBotao
      } as EnvioAutomaticoParametro;
    });
    if (this.envioAutomatico) {
      await EnviosAutomaticosService.manterEnvioAutomatico(this.envioAutomatico, envioAutomaticoParametros || []);
    }

    this.loading = false;
    return modal.close(true);
  }

  // Os parametros de botao ficam abaixo da dobra da modal. Sem uma mensagem, quem deixava um
  // select vazio la nao via o campo destacado e o salvar simplesmente nao acontecia -- ou,
  // antes da regra de obrigatoriedade, voltava um 500 generico do banco.
  private mensagemDeCamposPendentes(): string {
    if (!this.envioAutomatico?.template) {
      return "Selecione o template antes de salvar.";
    }

    const pendentes = (this.parametros ?? []).filter(p => !p.tipoParametro).length;
    if (pendentes === 0) {
      return "Confira os campos destacados antes de salvar.";
    }

    return pendentes === 1
      ? "1 parâmetro está sem conteúdo selecionado. Confira os campos destacados, inclusive os dos botões."
      : `${pendentes} parâmetros estão sem conteúdo selecionado. Confira os campos destacados, inclusive os dos botões.`;
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  obterBotao(index: number) {
    if (!this.templateSelecionado) return null;

    return this.templateSelecionado.botoes[index];
  }

  // O parametro guarda o indice do botao no template em que foi configurado. Se o template
  // atual tiver menos botoes, o indice nao existe mais e obterBotao devolve nada -- ler
  // .texto direto no markup quebrava a renderizacao e deixava a modal em loading infinito.
  obterTextoBotao(index: number): string {
    return this.obterBotao(index)?.texto ?? "";
  }
}
